<template>  
  <div>  
    <div class="row" id="dashboard">
      <h3>Atendimento</h3>
      <div class="col-lg-4">
        <AgendadosNoDia />
      </div>
      <div class="col-lg-4">
        <AtendimentosNoMomento /> 
      </div>
      <div class="col-lg-4">
        <MediaAtendimento />  
      </div>
    </div> 
    <div class="row">
      <h3>Estoque</h3>
      <div class="col-lg-6">
        <EstoqueNoMomento />
      </div>
      <div class="col-lg-6">
        <EstoqueUltimasBaixas />
      </div>
    </div>
  </div>
</template>
<script>
import AgendadosNoDia from './shared/dashboard/AgendadosNoDia.vue'
import AtendimentosNoMomento from './shared/dashboard/AtendimentosNoMomento.vue'
import MediaAtendimento from './shared/dashboard/MediaAtendimento.vue'
import EstoqueNoMomento from './shared/dashboard/EstoqueNoMomento.vue'
import EstoqueUltimasBaixas from './shared/dashboard/EstoqueUltimasBaixas.vue'
export default {
  components: {
    AgendadosNoDia,
    AtendimentosNoMomento,
    MediaAtendimento,
    EstoqueNoMomento,
    EstoqueUltimasBaixas
  },
  created: function () {
  }
}
</script>
<style> 
</style> 



// WEBPACK FOOTER //
// Dashboard.vue?dacc26e0